import React from "react";
import { Icon } from "~assets/frontend/elements/icon/Icon";
import Translator from "bazinga-translator";
import { getId } from "~assets/frontend/_util/getId";
export const SearchInput = ({ value, placeholder, suggestions, onInput }) => {
    const clearSearch = () => {
        onInput && onInput("");
    };
    const inputHandler = (event) => {
        if (event.target instanceof HTMLInputElement) {
            onInput && onInput(event.target.value);
        }
    };
    const selectSuggestion = (suggestion) => {
        onInput && onInput(suggestion);
    };
    const showSuggestions = suggestions.length > 0 && !!value && value.length > 3;
    return (React.createElement("div", { className: "relative max-w-full basis-full" },
        React.createElement("div", { className: "relative" },
            React.createElement("input", { autoFocus: true, type: "text", role: "searchbox", "aria-label": Translator.trans("frm-search.input-label", {}, "frontend"), value: value, className: "h-full w-full bg-anthracite-10 p-12 pl-48 text-22 xl:text-28", placeholder: placeholder, onInput: inputHandler }),
            React.createElement("span", { className: "absolute bottom-0 left-0 top-0 z-10 flex items-center p-12" },
                React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: "icon-search" })),
            value.length > 0 && (React.createElement("button", { onClick: clearSearch, "aria-label": Translator.trans("frm-search.clear-search", {}, "frontend"), className: "absolute bottom-0 right-0 top-0 p-12" },
                React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: "icon-close" })))),
        showSuggestions && (React.createElement("ul", { className: "absolute w-full bg-anthracite-10 py-6 pl-48", "aria-label": Translator.trans("frm-search.suggestions", {}, "frontend") }, suggestions.map((suggestion, index) => (React.createElement("li", { key: index, onClick: () => {
                selectSuggestion(suggestion);
            }, className: "py-6 text-18 " }, suggestion)))))));
};
